///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React, { useState, useEffect, useCallback } from "react";
import { FormattedMessage } from "react-intl";

import { status as bidStatus, userRole, repType, mode } from "../../helpers/types";
import getModeForUserRole from "../../helpers/getModeForUserRole";
import getOrdinalNumber from "../../helpers/getOrdinalNumber";
import messages from "../../helpers/messages";

export const BidStatusTag = ({ summary, role }) => {
  const [status, setStatus] = useState(null);
  const [color, setColor] = useState(null);

  const getCurrentRound = useCallback(round => {
    const ordinalNumber = (
      <FormattedMessage
        {...messages.ordinalNumberRound}
        values={{ ordinalNumber: getOrdinalNumber(round) }}
      />
    );
    setValues(ordinalNumber, "#616161");
  }, []);

  const checkStatusForSalesRep = useCallback(
    (modes, round) => {
      if (modes.some(x => x.status === bidStatus.rejected)) {
        setValues(messages.rejected.defaultMessage, "#B00020");
      } else if (
        modes.every(x => x.status === bidStatus.closed && x.isArchived === true)
      ) {
        setValues(messages.archived.defaultMessage, "#343434");
      } else if (round > 1) {
        getCurrentRound(round);
      }
    },
    [getCurrentRound]
  );

  const checkStatusForPricingUser = useCallback(
    (modes, round) => {
      const modeForRole = getModeForUserRole(role);
      if (modes.some(x => x.status === bidStatus.rejected && x.mode === modeForRole)) {
        setValues(messages.rejected.defaultMessage, "#B00020");
      } else if (
        modes.some(
          x =>
            x.status === bidStatus.closed &&
            x.isArchived === true &&
            x.mode === modeForRole
        )
      ) {
        setValues(messages.archived.defaultMessage, "#343434");
      } else if (round > 1) {
        getCurrentRound(round);
      }
    },
    [role, getCurrentRound]
  );

  useEffect(() => {
    const { modes, round } = summary;
    setValues(null, null);
    if (role === userRole.salesRep) {
      checkStatusForSalesRep(modes, round);
    } else {
      checkStatusForPricingUser(modes, round);
    }
  }, [summary, role, checkStatusForSalesRep, checkStatusForPricingUser]);

  const setValues = (statusValue, colorValue) => {
    setStatus(statusValue);
    setColor(colorValue);
  };

  return (
    <>
      {(role === userRole.tlPricingAnalyst ||
        role === userRole.assetBasedPricingUser) &&
        summary.modes.some(
          m => m.bidOwnerRepType === repType.sales && m.mode === mode.tl
        ) && (
          <div
            className="inline-block text-white grid--align-center bid-status-tag py-2 pos-relative align-top mt-4"
            style={{ backgroundColor: "#616161" }}
          >
            <p className="mb-0 font-bold" data-testid="Sales Only-tag">
              {messages.salesOnly.defaultMessage}
            </p>
          </div>
        )}
      {status && (
        <div
          className="inline-block text-white grid--align-center bid-status-tag py-2 pos-relative align-top mt-4"
          style={{ backgroundColor: color }}
        >
          <p
            className="mb-0 font-bold"
            data-testid={`${
              status.props
                ? status.props.values.ordinalNumber + " Round"
                : status
            }-tag`}
          >
            {status}
          </p>
        </div>
      )}
    </>
  );
};

export default BidStatusTag;
